export const getStepStyles = (components, { palette = {} } = {}) => {
  const color = {
    advancedTitleColor: palette.blue || '#0078D4',
    errorAlertColor: '#a4262c',
  };
  const commonFont = {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
  };
  const titleFont = {
    fontSize: 18,
    fontWeight: 400,
  };
  const subTitleFont = {
    fontSize: 14,
    fontWeight: 600,
  };
  const plainTextFont = {
    fontSize: 14,
    fontWeight: 400,
  };
  return ({
    contentBlock: {
      marginLeft: '26px',
      overflowX: 'hidden',
      overflowY: 'hidden',

      '& .btn-link': {
        color: '#0078d4',
        textDecoration: 'underline',
      },

      '& .tagConfirmationText': {
        marginLeft: '25px',
      },

      '& .alert': {
        border: 'none',
        boxShadow: 'none',
        fontSize: '12px',
        fontWeight: 400,
        color: '#323130',
        display: 'flex',
        height: 'auto',
        lineHeight: '16px',
        padding: '8px 32px 8px 8px',
        verticalAlign: 'middle',
      },
      '& .alert-info': {
        backgroundColor: '#eff6fc',
        borderColor: '#eff6fc',
        color: '#323130',

        '& .alert-image:before': {
          fontFamily: 'MsAds MDL2 Assets',
          fontSize: '16px',
          lineHeight: '16px',
          color: '#605e5c',
          marginRight: '8px',
          content: '\'\\E946\'',
        },
      },
      '& .alert-warning': {
        backgroundColor: '#fff4ce',
        borderColor: '#fff4ce',
        color: '#323130',

        '& .alert-image:before': {
          fontFamily: 'MsAds MDL2 Assets',
          fontSize: '16px',
          lineHeight: '16px',
          color: '#d83b01',
          marginRight: '8px',
          content: '\'\\E7BA\'',
        },
      },
      '& .alert-error': {
        backgroundColor: '#FDE7E9',
        borderColor: '#FDE7E9',
        color: '#323130',

        '& .alert-image:before': {
          fontFamily: 'MsAds MDL2 Assets',
          fontSize: '16px',
          lineHeight: '16px',
          color: '#d83b01',
          marginRight: '8px',
          content: '\'\\EA39\'',
        },
      },
    },
    instructionsHeader: {
      marginBottom: '7px',
    },
    buttonBlock: {
      '& *:not(:last-child)': {
        marginRight: '15px',
      },
    },
    loading: {
      backgroundColor: palette.white,
      paddingTop: '6px',
      paddingBottom: '6px',
      height: '100%',
    },
    radioButtonsBlock: {
      '& .ms-ChoiceFieldGroup': {
        '& label': {
          lineHeight: '12px',
          fontWeight: 400,
        },
      },
    },
    helpButton: {
      marginLeft: 5,
    },
    sendEmailsTextbox: {
      width: 268,
    },
    dropdownAddIcon: {
      fontSize: '16px',
      color: color.advancedTitleColor,
      marginRight: '5px',
      verticalAlign: 'bottom',
      fontWeight: 'bold',
    },
    eventParamRemoveIcon: {
      fontSize: '24px',
      verticalAlign: 'middle',
      cursor: 'pointer',
    },
    section: {
      marginBottom: 30,
      '& .ms-Checkbox-label': {
        alignItems: 'flex-start',
      },
    },
    defaultTitle: {
      extend: commonFont,
      lineHeight: '24px',
      ...titleFont,
      paddingBottom: '10.5px',
    },
    nonAccordionTitle: {
      extend: commonFont,
      lineHeight: '20px',
      ...subTitleFont,
      display: 'flex',
      '& .title': {
        marginRight: '6px',
      },
    },
    accordionTitle: {
      extend: commonFont,
      lineHeight: '24px',
      color: color.advancedTitleColor,
      ...subTitleFont,
      display: 'flex',
      '& a.title:after': {
        content: '"\\E70E"',
        float: 'left',
        fontFamily: 'MsAds MDL2 Assets',
        fontSize: '14px',
        transform: 'rotate(180deg)',
        marginRight: '11px',
      },
      '& a.collapsed:after': {
        transform: 'rotate(90deg)',
        transition: 'transform .1s linear',
      },
    },
    mainGoalBlock: {
      marginTop: 1,
    },
    accordionBlock: {
      marginBottom: '20px',
      marginLeft: '11px',

      '& .ms-ChoiceFieldGroup': {
        '& label': {
          lineHeight: '12px',
          fontWeight: 400,
        },
      },

      '& .displayBlock': {
        display: 'block',
      },

      '& .hideBlock': {
        display: 'none',
      },
    },
    attributeModelDropdown: {
      width: 100,
    },
    bodyText: {
      extend: commonFont,
      lineHeight: '20px',
      ...plainTextFont,
    },
    errorText: {
      extend: commonFont,
      lineHeight: '20px',
      ...plainTextFont,
      color: color.errorAlertColor,
      marginLeft: '20px',
    },
    inactiveText: {
      color: '#a19f9d',
    },
    timeInputBlock: {
      display: 'block',
    },
    eventParamSettingContainer: {
      paddingTop: 32,
      paddingBottom: 32,
      '& .row': {
        paddingBottom: 12,
      },
    },
    rowContainer: {
      display: 'flex',
      paddingTop: '6px',
      paddingBottom: '6px',
      '& .url-field': {
        marginLeft: '15px',
      },
    },
    tagDialogText: {
      '& .btn-link': {
        color: '#0078d4 !important',
        '&:focus, &:hover, &:active': {
          textDecoration: 'underline',
        },
      },
    },
    // tag-setup-choico new styles
    stepMargin: {
      marginLeft: '26px',
      marginBottom: '12px',
      marginRight: '26px',
    },
    topDescription: {
      marginBottom: 32,
    },
    inlineBanner: {
      backgroundColor: palette.themeLighterAlt,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'baseline',
      padding: '8px 0',
    },
    inlineBannerText: {
      display: 'block',
      marginLeft: 24,
    },
    subTitle: {
      fontWeight: 600,
      fontSize: 18,
      padding: 0,
      marginBottom: 7,
    },
    clarityUpsellContainer: {
      display: 'grid',
      gridTemplateColumns: '3fr 2fr 3fr',
      '& .grid-item': {
        paddingBottom: 40,
      },
      '& .grid-item:nth-child(-n+2)': {
        borderBottom: '1px solid lightgray',
      },
    },
    container: {
      fontSize: '14px',
      lineHeight: '24px',
      color: '#323130',
      marginLeft: 26,
      marginTop: 8,
      marginBottom: 12,
      '& .ms-Checkbox-label': {
        alignItems: 'flex-start',
      },
      display: 'flex',
      flexDirection: 'column',
    },
    imageContainer: { flex: '0 0 40%' },
    image: { maxWidth: 358, minWidth: 200 },
    checkListItem: {
      marginLeft: 8,
      display: 'inline-block',
    },
    switchToManualContainer: {
      marginTop: 0,
    },
    border: {
      marginTop: 32,
      border: 0,
      borderTop: '1px solid #B3B0AD',
      marginBottom: 12,
    },
  });
};
